import dayjs from "dayjs";
import { get } from "lodash";
import {
  MdNetworkPing,
  MdNumbers,
  MdOutlineBadge,
  MdOutlineCake,
  MdOutlineCall,
  MdOutlineHealthAndSafety,
  MdOutlineLocationOn,
  MdOutlineMediation,
  MdTripOrigin,
  MdWorkOutline,
} from "react-icons/md";
import { STEPS_KEYS } from "screens/Private/Broker/Clients/Create";
import Radio from "shared/components/Form/Radio";
import Input from "shared/components/Input";
import Switch from "shared/components/Input/Switch";
import Select from "shared/components/Select";
import {
  COMMUNICATION_CAMPAIGN_MEDIA,
  DATE_FORMAT,
  LMF_ASSOCIATION_MEMBER_TYPE,
  LMF_CONTACT_CANAL,
  LMF_ORIGINS,
  LMF_SOCIAL_REGIMES,
  PROFILE_LIST,
} from "utils/constants";
import { isMajor } from "utils/helpers/date";
import { bindDateInputProps, bindInputProps } from "utils/helpers/input";
export const step = { ADHERENT: "ADHERENT" };

const LMF_PROFILES = [
  PROFILE_LIST.PARTICULAR,
  PROFILE_LIST.TNS,
  PROFILE_LIST.TERRITORIAL_AGENT,
  PROFILE_LIST.THIS_FAMILY,
  PROFILE_LIST.C2SP,
  PROFILE_LIST.C2S_EXIT_CONTRACT,
  PROFILE_LIST.ASSOCIATION_MEMBER,
];

const Adherent = ({
  index,
  translation,
  values,
  setFieldValue,
  ...formProps
}) => {
  return (
    <div className="contact-stepper" key={step.ADHERENT}>
      <div className="contact-stepper__header">
        <div className="contact-stepper__header--counter">
          <span>{index}</span>
        </div>
        <div className="contact-stepper__header--content">
          <h1 className="contact-stepper__header--content--title">
            <span>
              {translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].TITLE}
            </span>
          </h1>
          <p className="contact-stepper__header--content--description">
            {translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].DESCRIPTION}
          </p>
        </div>
      </div>
      <div className="contact-stepper__content">
        <Input
          label={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.GRA_CODE
              .LABEL
          }
          icon={<MdNumbers size={22} />}
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.GRA_CODE
              .PLACEHOLDER
          }
          {...bindInputProps({
            name: "fields.graCode",
            values,
            ...formProps,
          })}
        />
        <Radio
          label={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.CIVILITY
              .LABEL
          }
          options={[
            {
              label:
                translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.CIVILITY
                  .MALE,
              value: "M",
            },
            {
              label:
                translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.CIVILITY
                  .FEMALE,
              value: "F",
            },
          ]}
          icon={<MdOutlineBadge size={22} />}
          {...bindInputProps({
            name: "contact.user.gender",
            values,
            ...formProps,
          })}
        />
        <Input
          label={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.LASTNAME
              .LABEL
          }
          icon={<MdOutlineBadge size={22} />}
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.LASTNAME
              .PLACEHOLDER
          }
          {...bindInputProps({
            name: "contact.user.lastname",
            values,
            ...formProps,
          })}
        />
        <Input
          label={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.FIRSTNAME
              .LABEL
          }
          icon={<MdOutlineBadge size={22} />}
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.FIRSTNAME
              .PLACEHOLDER
          }
          {...bindInputProps({
            name: "contact.user.firstname",
            values,
            ...formProps,
          })}
        />
        <Input
          icon={<MdOutlineCake size={22} />}
          label={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.BIRTHDAY
              .LABEL
          }
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[step.ADHERENT].FORM.BIRTHDAY
              .PLACEHOLDER
          }
          type="date"
          variant="simple"
          format={DATE_FORMAT}
          disabledDate={(current) => current > isMajor}
          defaultPickerValue={
            !get(values, "contact.user.birthDate") &&
            dayjs().subtract(30, "years")
          }
          {...bindDateInputProps({
            name: "contact.user.birthDate",
            values,
            setFieldValue,
            ...formProps,
          })}
        />
        <Input
          icon={<MdOutlineLocationOn size={22} />}
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .ZIPCODE.PLACEHOLDER
          }
          label={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .ZIPCODE.LABEL
          }
          {...bindInputProps({
            name: "zipCode.value",
            values,
            ...formProps,
          })}
        />
        <Input
          icon={<MdOutlineCall size={16} />}
          type="phone"
          inputMode="numeric"
          maxLength={10}
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM.PHONE
              .PLACEHOLDER
          }
          label={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM.PHONE
              .LABEL
          }
          {...bindInputProps({
            name: "phoneNumber.value",
            values,
            ...formProps,
          })}
        />
        <Select
          icon={<MdOutlineHealthAndSafety size={22} />}
          options={Object.entries(LMF_SOCIAL_REGIMES).map(([key, value]) => ({
            value,
            label: translation.LMF_SOCIAL_REGIMES[key],
          }))}
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .SOCIAL_REGIME.PLACEHOLDER
          }
          label={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .SOCIAL_REGIME.LABEL
          }
          {...bindInputProps({
            name: "contact.socialRegime",
            values,
            ...formProps,
          })}
        // onChange={(value) => {
        //   setFieldValue("contact.socialRegime", value);
        //   if (value !== SOCIAL_REGIMES.REGIME_SALARIES_AGRICOLES) {
        //     setFieldValue(
        //       "contact.socioProfessionalCategory",
        //       SOCIO_PROFESSIONAL_CATEGORIES.OTHER
        //     );
        //     setFieldValue("contact.exerciseFrame", null);
        //   }
        // }}
        />
        <Select
          showSearch
          icon={<MdWorkOutline size={16} />}
          options={LMF_PROFILES.map((value) => ({
            value,
            label:
              translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                .PROFILES.OPTIONS[value],
          })).sort((a, b) => get(a, "label", "").localeCompare(b.label))}
          label={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .PROFILE.LABEL
          }
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .PROFILE.PLACEHOLDER
          }
          {...bindInputProps({
            name: "contact.fields.profile",
            values,
            ...formProps,
          })}
          onChange={(value) => {
            setFieldValue("contact.fields.profile", value);
            setFieldValue("contact.fields.associationMemberType", undefined);
          }}
        />
        {get(values, "contact.fields.profile") ===
          PROFILE_LIST.ASSOCIATION_MEMBER && (
            <Select
              showSearch
              icon={<MdWorkOutline size={16} />}
              options={Object.entries(LMF_ASSOCIATION_MEMBER_TYPE)
                .map(([key, value]) => ({
                  value,
                  label: translation.LMF_ASSOCIATION_MEMBER_TYPE[key],
                }))
                .sort((a, b) => get(a, "label", "").localeCompare(b.label))}
              label={
                translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                  .SUB_PROFILE.LABEL
              }
              placeholder={
                translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                  .SUB_PROFILE.PLACEHOLDER
              }
              {...bindInputProps({
                name: "contact.fields.subProfile",
                values,
                ...formProps,
              })}
            />
          )}
        <div className="contact-stepper__content--radio">
          <span className="contact-stepper__content--radio--title flex--grow-1">
            {
              translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                .IS_LMF_CLIENT
            }
          </span>
          <Switch
            className="contact-stepper__content--radio--switch button__switch"
            checkedChildren={
              translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                .OPTIONS.YES
            }
            unCheckedChildren={
              translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                .OPTIONS.NO
            }
            defaultChecked={get(values, "contact.fields.isClient")}
            onChange={(value, _) => {
              setFieldValue("contact.fields.isClient", value);
            }}
          />
        </div>
        <div className="contact-stepper__content--radio">
          <span className="contact-stepper__content--radio--title flex--grow-1">
            {
              translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                .IS_C2S
            }
          </span>
          <Switch
            className="contact-stepper__content--radio--switch button__switch "
            checkedChildren={
              translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                .OPTIONS.YES
            }
            unCheckedChildren={
              translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                .OPTIONS.NO
            }
            defaultChecked={get(values, "fields.info.cssBeneficiary")}
            onChange={(value, _) => {
              setFieldValue("fields.info.cssBeneficiary", value);
            }}
          />
        </div>
        <Select
          showSearch
          icon={<MdTripOrigin size={16} />}
          options={Object.entries(LMF_ORIGINS).map(([key, value]) => ({
            value,
            label: translation.LMF_ORIGINS[key],
          }))}
          label={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM.ORIGIN
              .LABEL
          }
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM.ORIGIN
              .PLACEHOLDER
          }
          {...bindInputProps({
            name: "contact.fields.membershipOrigin",
            values,
            ...formProps,
          })}
          onChange={(value) => {
            setFieldValue("contact.fields.membershipOrigin", value);
            setFieldValue("contact.fields.membershipSubOrigin", undefined);
          }}
        />
        {get(values, "contact.fields.membershipOrigin") ===
          LMF_ORIGINS.COMMUNICATION_CAMPAIGN && (
            <Select
              showSearch
              icon={<MdNetworkPing size={16} />}
              options={Object.entries(COMMUNICATION_CAMPAIGN_MEDIA).map(
                ([key, value]) => ({
                  value,
                  label: translation.COMMUNICATION_CAMPAIGN_MEDIA[key],
                })
              )}
              label={
                translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                  .COMMUNICATION_CAMPAIGN.LABEL
              }
              placeholder={
                translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
                  .COMMUNICATION_CAMPAIGN.PLACEHOLDER
              }
              {...bindInputProps({
                name: "contact.fields.membershipSubOrigin",
                values,
                ...formProps,
              })}
            />
          )}
        <Select
          showSearch
          icon={<MdOutlineMediation size={16} />}
          options={Object.entries(LMF_CONTACT_CANAL).map(([key, value]) => ({
            value,
            label: translation.LMF_CONTACT_CANAL[key],
          }))}
          label={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .CONTACT_CANAL.LABEL
          }
          placeholder={
            translation.TEMPLATES.CONTACT.STEPS[STEPS_KEYS.ADHERENT].FORM
              .CONTACT_CANAL.PLACEHOLDER
          }
          {...bindInputProps({
            name: "contact.fields.contactCanal",
            values,
            ...formProps,
          })}
        />
      </div>
    </div>
  );
};
export default Adherent;
